import { oneDataFetchye } from '@americanexpress/fetchye-amex';
import { setAuthentication } from '../ducks/authDuck';

// istanbul ignore next
const onEnterAuthenticate = (store) => async (nextState, replace, callback) => {
  const { data } = await store.dispatch(oneDataFetchye('ReadUserSession.v1', {
    method: 'GET',
  }));

  await store.dispatch(setAuthentication(!!data?.ok));

  callback();
};

export default onEnterAuthenticate;
